// Third Party Library
import React, { useState } from "react";
import { Layout, Space, Row, Col, Form, Input, message, Card } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Constants
import { ROOT_CONSTANT, ROUTE } from "../../../../constants";

import SSOFPFooter from "../SSOFPFooter";

import * as ACTIONS from "../../../../services/redux/actions";

// Style
import styles from "../../../index.module.css";
import "./index.css";

// Components
import { LoginHeader, CopyRightFooter } from "../../../../components";

const { Content } = Layout;
const { MODULE_ROUTE } = ROUTE;

const theme_color = ROOT_CONSTANT.THEME.THEME_COLOR;

const SSOForgotPassword6DigitsCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();

  const user = useSelector((state) => state.containers.main.user);
  const link = user.link;
  const email = user.email;

  const [loadingReset, setLoadingReset] = useState(false);
  const [otp, setOtp] = useState(null);

  const onFinish = () => {

    form.validateFields().then(() => {
      const pin = otp;

      messageApi.open({
        type: "loading",
        content: "Checking the pin...",
        duration: 0,
      });

      dispatch(
        ACTIONS.main_verify.sso_verify_link_request(
          link,
          pin,
          ({ extra, status, err }) => {
            if (status === 202) {
              messageApi.destroy();
              setLoadingReset(false);
              navigate(ROUTE.MODULE_ROUTE.FORGOT_PASSWORD_NEW_PASSWORD, {
                state: { verify: true, ...extra },
              });
            } else {
              messageApi.destroy();
              setLoadingReset(false);
              message.error(err);
            }
          }
        )
      );
      setLoadingReset(true);
    }).catch(() => message.error("Please input the 6 digits code!"))
  };

  return (
    <>
      {contextHolder}
      <div className={styles.mainWrap}>
        <Card className={styles.mainCard}>
          <Space direction="vertical" style={{ width: "100%" }} size={[0, 48]}>
            <Layout style={{ backgroundColor: "#ffffff" }}>
              <LoginHeader />

              <Content style={{ marginTop: "40px" }}>
                <Col style={{ textAlign: "center" }} span={8} offset={8}>
                  <h2 className={styles.textTitle}>Check Email</h2>
                  <p className={styles.textDetailsForgetPass}>
                    We’ve send you a code to
                    <Link
                      to=""
                      className={styles.textDetailsForgetPass}
                      style={{ color: theme_color }}
                    >
                      {email}.
                    </Link>
                    To reset your password, please enter the code to proceed
                    further.
                  </p>

                  <Form
                    form={form}
                    name="normal_login"
                    initialValues={{
                      remember: true,
                    }}
                    layout="vertical"
                  >
                    <Form.Item
                      label="6 Digits Code"
                      name="code"
                      rules={[
                        {
                          required: true,
                          message: "Please input the 6 digits code!",
                        },
                      ]}
                    >
                      <Row>
                        <Col>
                          <Input.OTP
                            style={{
                              width: "30vw",
                              fontSize: "26px",
                            }}
                            onChange={(value) => setOtp(value)}
                          />
                        </Col>
                      </Row>
                    </Form.Item>
                  </Form>
                </Col>
              </Content>
              <SSOFPFooter
                loading={loadingReset}
                page={MODULE_ROUTE.FORGOT_PASSWORD}
                submit={onFinish}
              />
            </Layout>
          </Space>
        </Card>

        <CopyRightFooter />
      </div>
    </>
  );
};

export default SSOForgotPassword6DigitsCode;
